<template>
	<v-dialog
		v-model="dialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white"
					>{{ receivingDate | dateFormatter }}　{{ productName }}　入庫個数
				</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark color="white" @click="closeDialog()">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>

			<v-form class="pa-2" ref="form" v-model="valid" lazy-validation>
				<v-text-field
					type="number"
					hint="入庫する個数を入力してください"
					class="mt-4"
					outlined
					dense
					v-model="planned_quantity"
					:readonly="!authorityFlag"
				/>
			</v-form>
			<v-card-actions>
				<v-row no-gutters class="pb-2">
					<v-col cols="4" />
					<v-col cols="4">
						<v-row no-gutters justify="center">
							<v-btn color="secondary" @click="changeReceivingQuantity()" :disabled="!isValid">
								<v-icon class="mr-2">mdi-plus</v-icon>
								登録する
							</v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import rules from "../../../helper/rules"
import moment from "moment"
import "moment/locale/ja"

export default {
	props: {
		product_id: {
			type: Number,
			required: true,
		},
		authorityFlag: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	filters: {
		dateFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("MM/DD(dd)")
		},
		monthFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("YYYY年MM月")
		},
	},
	data() {
		return {
			rules: rules,
			dialog: false,
			planned_quantity: "",
			productName: "",
			receivingDate: "",
			id: "",
			receiving_id: "",
			valid: false,
			products: {},
		}
	},

	methods: {
		openDialog(name, date, id, receiving_id, current_planned_quantity) {
			this.dialog = true
			this.componentName = name
			this.id = id
			this.receivingDate = date
			this.receiving_id = receiving_id
			this.fetchReceivingQuantity(current_planned_quantity)
		},
		closeDialog() {
			this.dialog = false
			this.$refs.form.reset()
		},

		fetchReceivingQuantity(current_planned_quantity) {
			this.planned_quantity = current_planned_quantity
		},

		changeReceivingQuantity() {
			const headers = authenticate.setHeader()
			if (this.planned_quantity != 0) {
				axios
					.put(
						`/erp/v1/product_stocks/${this.receiving_id}`,
						{ planned_quantity: this.planned_quantity },
						{ headers }
					)
					.then((res) => {
						this.closeDialog()
						this.receiving_shipping = res.data.receiving_shipping
						this.$emit("reload-show", this.receiving_shipping)
					})
					.catch((err) => {
						errorHandling.errorResponse(err)
					})
			} else {
				axios
					.delete(`/erp/v1/product_stocks/${this.receiving_id}`, {
						headers,
					})
					.then((res) => {
						this.closeDialog()
						this.receiving_shipping = res.data.receiving_shipping
						this.$emit("reload-show", "", this.receiving_shipping)
					})
					.catch((err) => {
						errorHandling.errorResponse(err)
					})
			}
		},
		isPresence(value) {
			return value !== null && value !== ""
		},
	},
	computed: {
		isValid() {
			if (this.isPresence(this.planned_quantity)) {
				return true
			} else {
				return false
			}
		},
	},
}
</script>
